export default __webpack_public_path__ + "5f3ac7f1dec2068a63460fa5586c08d3.svg";